<template>
	<section ref="el" data-component="body">
		<div class="g-row">
			<div class="g-col xxl-8 xxl-offset-7 xs-16 xs-offset-0">
				<BodyBlocks :content="content" variant="article" />
				<div class="legal-disclaimer">
					<span class="line" />
					<SanityContent :value="legalDisclaimer" />
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
import { BodyBlocks } from '~/components/fragments'

defineProps({
	content: { type: Array, default: undefined },
	legalDisclaimer: { type: Array, default: undefined },
})

const el = ref(null)
const context = inject('pageContext')

const setup = () => {}
const init = () => {}

onBeforeUnmount(() => {})
onMounted(() => {
	context.$page.loader.loaded.then(() => setup())
	context.$page.loader.transitionReady.then(() => init())
})
</script>

<style lang="scss" scoped>
[data-component='body'] {
	position: relative;

	display: flex;

	width: 100%;
	min-height: 100vh;

	margin-top: rs(64, 12);

	.-variant-article {
		@include max-width($xs) {
			padding: 0 column-width(1, true);
		}
	}

	:deep(.legal-disclaimer) {
		margin-bottom: rs(150, 20);
		padding-bottom: rs(10, 10);

		.line {
			padding-top: rs(10, 10);

			width: 100%;
			height: 1px;
			border-top: 1px solid var(--color-neutral-tints-200);
		}

		@include max-width($xs) {
			padding: 0 column-width(1, true);
		}

		p {
			@include caption-regular;
			color: var(--color-neutral-tints-700);

			strong {
				@include caption-medium;
				color: var(--color-neutral-tints-700);
			}
		}
	}
}
</style>
